import type { WebChannelSeoConfig } from '@repo/api/web/models'

/**
 * Per-channel SEO-настройки текущей витрины (`GET seo/config`).
 *
 * Грузятся один раз на SSR плагином seoConfigLoader и переезжают на клиент
 * через payload — useState, а не appConfig: appConfig на сервере не реактивен.
 * Пока не загружено (или API недоступен) — null, и вся мета честно падает
 * на авто-генерацию SeoService.
 */
export const useSeoConfig = () =>
  useState<WebChannelSeoConfig | null>('seo:config', () => null)
